import { IdentityServerConfig } from "./models";

export class TokenService {
    public static componentName = "tokenService";

    public get accessToken(): string {
      return sessionStorage.getItem(IdentityServerConfig.AccessTokenKey) || "";
    }
  
    public set accessToken(token: string) {
      sessionStorage.setItem(IdentityServerConfig.AccessTokenKey, token);
    }
  
    public get hasToken(): boolean {
      return this.accessToken !== null;
    }
  
    public clear(): void {
      sessionStorage.removeItem(IdentityServerConfig.AccessTokenKey);
    }
  }
  
  
angular.module("topline.services").service(TokenService.componentName, TokenService);
